import gql from 'graphql-tag';

const unexpireGuaranteePurchaseMutation = gql`
  mutation unexpireGuaranteePurchase(
    $unexpireInput: UnexpireGuaranteePurchaseInput!
  ) {
    unexpireGuaranteePurchase(input: $unexpireInput) {
      success
      errors
    }
  }
`;

export default unexpireGuaranteePurchaseMutation;
